<template>
  <div class="retail">
    <Tabs
      title="Заказы поставщику"
      :tabs="tabs"
      :active="tabActive"
      @tabActiveUpdate="updateOrdersTab"
      class="tab--table"
    >
      <template #tabsAfter>
        <OrderRate @changeCurrency="changeCurrency" :currency="currency" />
      </template>
      <template #multiselectAfter
        ><OrderRate @changeCurrency="changeCurrency" :currency="currency" />
      </template>
      <Journal
        v-if="tabActive === tabs[0].path"
        inputId="supplier"
        :list="suppliersOrder ? suppliersOrder.data : []"
        :supplier="true"
        :isSelectedList="true"
        :pagination="suppliersOrder ? suppliersOrder.pagination : null"
        :tabActive="tabActive"
        :currency="currency"
        @updateJournal="updateOrders"
      >
      </Journal>
      <Journal
        v-if="tabActive === tabs[1].path"
        inputId="supplier-archived"
        :list="suppliersOrderArchived ? suppliersOrderArchived.data : []"
        :supplier="true"
        :archived="true"
        :isSelectedList="true"
        :pagination="suppliersOrderArchived ? suppliersOrderArchived.pagination : null"
        :tabActive="tabActive"
        :currency="currency"
        @updateJournal="updateOrders"
      >
      </Journal>
    </Tabs>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';

import Orders from '@/mixins/Account/orders.mixin';
import currencyMixin from '@/mixins/currency.mixin'

import { ORDER_TYPE } from '@/store/modules/account/variables';
export default {
  name: 'AccountOrdersSupplier',

  components: {
    Tabs: () => import('@/pages/account/components/Tabs'),
    Journal: () => import('./components/journal/Journal'),
    OrderRate: () => import('@/components/OrderRate'),
  },

  mixins: [Orders, currencyMixin],

  metaInfo() {
    return {
      title: `Заказы поставщику - Личный кабинет дилера - ${this.getDealerName}`,
    };
  },

  data: () => ({
    type: ORDER_TYPE.supplier,
  }),

  computed: {
    ...mapState({
      suppliersOrder: state => state.account.orders.suppliersOrder,
      suppliersOrderArchived: state => state.account.orders.suppliersOrderArchived,
    }),

    ...mapGetters('user', ['getDealerName']),
  },
};
</script>

